/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Qr_LoadingInputs */

const vi_payment_qr_loading = /** @type {(inputs: Payment_Qr_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải mã QR...`)
};

/**

* @param {Payment_Qr_LoadingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const payment_qr_loading = /** @type {((inputs?: Payment_Qr_LoadingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Qr_LoadingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_payment_qr_loading(inputs)
});